import { useContext } from "react";

import { useOverlayOptionId } from "./overlay/useOverlayOptionId";
import { OptionPageSupportContext } from "./OptionPageSupportContext";

export const OPTION_WRITES_BLOCKED_MESSAGE =
  "Edits are disabled while a design option is selected. Switch to Baseline to edit.";

/**
 * True while a design option is selected. Writers that are not option-aware
 * (header Allocate, profile images, AI chat) change the baseline every option
 * is built on, so they disable themselves for as long as this is true.
 */
export const useOptionWritesBlocked = (): boolean =>
  Boolean(useOverlayOptionId());

/**
 * True while a design option is selected and the current page is not
 * `supported`. Option-aware writers on a read-only page would write the
 * option while the page shows baseline, so they disable themselves here.
 * Outside `OptionPageGuard` the page is unknown, which counts as not supported.
 */
export const useOptionPageWritesBlocked = (): boolean => {
  const optionSelected = Boolean(useOverlayOptionId());
  const support = useContext(OptionPageSupportContext);
  return optionSelected && support !== "supported";
};
